export default __webpack_public_path__ + "static/media/yeezy.e4879588.jpg";